import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { Field, Form } from 'redux-form'
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup"
import withForm from 'with/Form'

import TextField from 'components/TextField'
import Button from 'components/buttons/Button'
import FormWithActions from 'layout/FormWithActions'
import Delete from 'components/Delete'

import handleFormErrors from 'utils/handleFormErrors'

import { LoadingBox } from 'components/LoadingSpinner'

import UsersAPI from 'api/UsersAPI'

import schema from './schema'
import styles from './index.css'

@withForm({
  asyncValidate : asyncValidate(schema),
  shouldAsyncValidate
})
export default class AdminForm extends React.Component {
  
  static propTypes = {
    form        : PropTypes.string.isRequired,
    submitLabel : PropTypes.string,
    onClose     : PropTypes.func,
    onSubmit    : PropTypes.func.isRequired,
  }

  static defaultProps = {
    onClose : () => {}
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <Form form={this.props.form} onSubmit={handleSubmit}>
        <FormWithActions title={this.props.title}
          actions={[
            <Button 
              key={0}
              type='button'
              color='grey'
              onClick={() => this.props.onClose()}
              >
              Cancel
            </Button>
            ,
            <Button 
              key={1}
              loading={this.props.submitting}
              type='submit'
              color='orange' 
              style={{margin: '2rem 0rem'}}>
              {this.props.submitLabel || 'Save'}
            </Button>
          ]}>
          <Field 
            name='name' 
            label='Admin Name'
            type='text'
            component={TextField} 
            />
          <Field 
            name='email' 
            label='Email'
            type='email'
            component={TextField} 
            />
          <Field 
            name='password' 
            label='Password'
            type='password'
            component={TextField} 
            />
        </FormWithActions>
      </Form>
    )
  }
}


export class AddAdminForm extends React.Component {
    
  static propTypes = {
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (values) => {
    const {response} = handleFormErrors(await UsersAPI.createAdmin(values))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    return (
      <AdminForm 
        form={"AddAdminForm"}
        title={"Add Admin"}
        submitLabel={"Add Admin"}
        onClose={this.props.onClose}
        onSubmit={this.submit}
        />
    )
  }
}



export class EditAdminForm extends React.Component {
    
  static propTypes = {
    id : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  state = {
    initialValues : null
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  async componentDidMount() {
    const res = await UsersAPI.getUser(this.props.id)
    if (res.response) {
      this.setState({ initialValues: { ...res.response } })
    }
  }

  submit = async (values) => {
    const {response} = handleFormErrors(await UsersAPI.updateAdmin(this.props.id, values))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    const { initialValues } = this.state
    if (!initialValues) return <LoadingBox />
    return (
      <AdminForm 
        initialValues={initialValues}
        form={"EditAdminForm"}
        title={"Edit Admin"}
        submitLabel={"Edit Admin"}
        onClose={this.props.onClose}
        onSubmit={this.submit}
        />
    )
  }
}


export class DeleteAdminForm extends React.Component {
    
  static propTypes = {
    id : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (event) => {
    const {response} = handleFormErrors(await UsersAPI.deleteUser(this.props.id))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    return (
      <Delete 
        title={"Delete Admin"}
        submitLabel={"Delete Admin"}
        entityName={"this Admin"}
        onCancel={this.props.onClose}
        onConfirm={this.submit}
        />
    )
  }
}



// WEBPACK FOOTER //
// ./src/forms/Admin/index.jsx